import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogFooter,
} from "@component/dialog";
import { Button } from "@component/button";
import { Applicant } from "@type/applicant";

interface RejectionReasonDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    applicant: Applicant;
}

export function RejectionReasonDialog({
    open,
    onOpenChange,
    applicant
}: RejectionReasonDialogProps) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-md overflow-y-auto max-h-[90vh]">
                <DialogHeader>
                    <DialogTitle className="text-xl">Offer Rejection Details</DialogTitle>
                </DialogHeader>
                <div className="space-y-4 py-2">
                    <div className="space-y-1">
                        <p className="text-sm font-medium text-gray-500 dark:text-gray-400">
                            Candidate
                        </p>
                        <p className="font-medium">{applicant.applicant_name || applicant.cv_data?.CV_data?.name || "—"}</p>
                    </div>

                    {/* {rejectionDate && (
                        <div className="space-y-1">
                            <p className="text-sm font-medium text-gray-500 dark:text-gray-400">
                                Rejection Date
                            </p>
                            <p>{rejectionDate}</p>
                        </div>
                    )} */}

                    <div className="space-y-1">
                        <p className="text-sm font-medium text-gray-500 dark:text-gray-400">
                            Selected Reason for Rejection
                        </p>
                        <div className="bg-gray-50 dark:bg-gray-800 p-3 rounded-md border border-gray-200 dark:border-gray-700">
                            <p className="text-gray-700 dark:text-gray-300 font-medium">
                                {applicant.decline_reason}
                            </p>
                        </div>
                    </div>

                    <div className="space-y-1">
                        <p className="text-sm font-medium text-gray-500 dark:text-gray-400">
                            Detailed Explanation from Candidate
                        </p>
                        <div className="bg-gray-50 dark:bg-gray-800 p-3 rounded-md border border-gray-200 dark:border-gray-700">
                            <p className="text-gray-700 dark:text-gray-300 whitespace-pre-wrap">
                                {applicant.message_to_company}
                            </p>
                        </div>
                    </div>
                </div>
                <DialogFooter>
                    <Button onClick={() => onOpenChange(false)}>Close</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
